import { css } from '@emotion/css';

export const overrideButtonStyles = css`
  flex-shrink: 0;
  // course editor overrides the font sizes of token, so directly using body-short-02 was resulting in big fontg size.
  // Here we are using the same font size as body-short-02
  justify-content: space-between;
  font-size: 1.4rem;
  line-height: 2.2rem;
  font-weight: 400;
`;

export const codeBlockHoverStyles = css`
  .action-btns {
    opacity: var(--is-hovered, 0);
    transition: opacity 0.2s ease 0.1s;
  }

  .action-btns.open,
  .action-btns:hover,
  .action-btns:focus {
    opacity: 1;
  }
`;

export const onHoverContainer = css`
  position: relative;
  &:hover {
    --is-hovered: 1;
  }

  &:has(.action-btns.open),
  &:has(.action-btns:hover),
  &:has(.action-btns:focus) {
    --is-hovered: 1;
  }
`;
